export default "__VITE_ASSET__Lt3uRhbX__"